import type { AdKind, MarkAd } from '../../api';

/** Marknadsplatsen listar bara annonser – jaktmarker visas inte som egen listning. Markens publika sida nås via annonsen eller gamla länkar. */
export type JaktSubTab = 'jaktlag' | 'enskilda' | 'jaktklubbar' | 'jaktpaket';
export const JAKT_SUB_TABS: [JaktSubTab, string][] = [['jaktlag', 'Jaktlag'], ['enskilda', 'Enskilda jakter'], ['jaktklubbar', 'Jaktklubbar'], ['jaktpaket', 'Jaktpaket']];
export const DEFAULT_JAKT_SUB_TAB: JaktSubTab = 'jaktlag';

export const MARKETPLACE_AD_KINDS: readonly AdKind[] = ['jaktlag', 'enskild', 'jaktklubb', 'jaktpaket'];

/** Behåll bara annonser av de fyra typerna som har en mark att visa. */
export function marketplaceAds(ads: readonly MarkAd[]): MarkAd[] {
  return ads.filter(a => (MARKETPLACE_AD_KINDS as readonly string[]).includes(a.kind) && !!a.mark);
}
